document.querySelectorAll('.main-nav__tier-1-item').forEach(item => {
    if (!item.querySelector('summary')) {
      item.classList.add('no-summary');
    }
  });

  let tabsInitialized = false;

  function createProductDescriptionTabs() {
    if (tabsInitialized) return;

    const container = document.querySelector('.product__description');
    if (!container || container.querySelector('.product-description-tabs')) return;

    const h4 = container.querySelector('h4');
    if (!h4) return;

    const nodes = Array.from(container.childNodes);
    let description = '';
    let specifications = '';
    let isSpecs = false;

    for (const node of nodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;

      if (node.tagName === 'H4') isSpecs = true;

      if (isSpecs) {
        specifications += node.outerHTML;
      } else {
        description += node.outerHTML;
      }
    }

    if (!description.trim() || !specifications.trim()) return;

    // Clean up specifications content
    specifications = cleanSpecificationsContent(specifications);

    container.innerHTML = `
      <div class="product-description-tabs">
        <div class="product-description-tab-buttons">
          <button class="product-description-tab-button active" data-tab="description">Description</button>
          <button class="product-description-tab-button" data-tab="specifications">Specifications</button>
        </div>
        <div class="product-description-tab-content">
          <div class="product-description-tab-panel active" data-tab="description">${description}</div>
          <div class="product-description-tab-panel" data-tab="specifications">${specifications}</div>
        </div>
      </div>
    `;

    const buttons = container.querySelectorAll('.product-description-tab-button');
    const panels = container.querySelectorAll('.product-description-tab-panel');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        buttons.forEach(b => b.classList.toggle('active', b === btn));
        panels.forEach(p => p.classList.toggle('active', p.dataset.tab === target));
      });
    });

    tabsInitialized = true;
  }

  // Function to clean up redundant divs from specifications
  function cleanSpecificationsContent(content) {
    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Find all the redundant wrapper divs
    const redundantDivs = tempDiv.querySelectorAll('.tab-pane.fade.active.in, .row.marginnone, .col-md-6, .speclistdiv');
    
    // If we find the actual content (ul element), extract it
    const ulElement = tempDiv.querySelector('ul');
    if (ulElement) {
      // Get the h4 element if it exists
      const h4Element = tempDiv.querySelector('h4');
      let cleanedContent = '';
      
      if (h4Element) {
        cleanedContent += h4Element.outerHTML;
      }
      
      cleanedContent += ulElement.outerHTML;
      return cleanedContent;
    }

    // If no ul found, try to find the deepest content
    let deepestContent = tempDiv;
    while (deepestContent.children.length === 1) {
      deepestContent = deepestContent.children[0];
    }

    // If we found content, return it
    if (deepestContent.innerHTML.trim()) {
      return deepestContent.innerHTML;
    }

    // Fallback to original content
    return content;
  }

  ['DOMContentLoaded', 'load'].forEach(evt => {
    window.addEventListener(evt, createProductDescriptionTabs);
  });
